import { ChevronDownIcon } from "@100mslive/react-icons";
import {
    Avatar,
    Checkbox,
    Dialog,
    DialogContent,
    Hidden,
    InputAdornment,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Menu,
    MenuItem,
    TextField,
    Tooltip,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from "react-accessible-accordion";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import _ from "underscore";
import uploadingImg from "../../assets/images/calculator.png";
import { IsNullOrEmpty, validEmail, validPhone } from "../../helpers/utility";
import {
    getCartRequest,
    updateCartRequest,
} from "../../store/shopping/shopping.actions";
import { getCartList } from "../../store/shopping/shopping.selector";
import { getDeliveryAddressRequest } from "../../store/user/deliveryaddress/deliveryaddress.actions";
import DeliveryAddressAPI from "../../store/user/deliveryaddress/deliveryaddress.api";
import { getDeliveryAddresses } from "../../store/user/deliveryaddress/deliveryaddress.selector";
import { getImage, getUserProfile } from "../../store/user/user.selector";
import AddAddress from "../AccountPreferences/addAddress";
import OrderPayment from "./order_payment";

var api_key = process.env.REACT_APP_GOOGLE_API_KEY;
var currency = "";

const InstantCart = (props) => {
    const scrollRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
    const [add, isAdd] = useState(false);
    const [shipment, setShipment] = useState({});
    const [courier, setCourier] = useState({});
    const [selectedAddress, setSelectedAddress] = useState("");
    const [confirmPayment, setConfirmPayment] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [calculating, setCalculating] = useState(false);
    const [rates, setRates] = useState([]);
    const [selectedRate, setSelectedRate] = useState({});
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [address1, setAddress1] = useState("");
    const [city, setCity] = useState("");
    const [discount, setDiscount] = useState(0);
    const [discountCode, setDiscountCode] = useState("");
    const [postCode, setPostCode] = useState("");
    const [email, setEmail] = useState("");
    const [state, setCurState] = useState("");
    const [nickName, setNickName] = useState("");
    const [isNew, setNew] = useState(false);
    const [form, setForm] = useState(false);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedIndex, setSelectedIndex] = React.useState(1);

    const { carts, deliveryAddresses, userProfile, deliveryLoading } =
        useSelector((state) => {
            return {
                carts: getCartList(state),
                deliveryAddresses: getDeliveryAddresses(state),
                userProfile: getUserProfile(state),
                deliveryLoading: state.DeliveryAddressReducer.isLoading,
            };
        });

    useEffect(() => {
        if (
            carts.cartItems &&
            carts.cartItems.length === 0
        ) {
            navigate(-1)
        }
    }, [carts])

    useEffect(() => {
        if (deliveryAddresses.length === 0 && !deliveryLoading) {
            isAdd(true);
        }
    }, [deliveryAddresses, deliveryLoading]);

    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [accordionOne, setAccordionOne] = useState(true);

    const handleAccordionOne = (e) => {
        const accordionToggle = document
            .querySelector(".accordionToggleOne")
            .getAttribute("aria-expanded");
        if (accordionToggle === "true") {
            setAccordionOne(true);
        } else {
            setAccordionOne(false);
        }
    };

    const dispatch = useDispatch();

    const getCountryByCode = (code) => {
        if (code == "+65") return "SG";
        if (code == "+60") return "MY";
        if (code == "+1") return "US";
    };

    useEffect(() => {
        if (
            !IsNullOrEmpty(selectedAddress._id) &&
            carts.cartItems &&
            carts.cartItems.length > 0
        ) {
            setCalculating(true);
            let ids = selectedItems.map((x) => x.product && x.product.user.id);
            let curItems = selectedItems;
            DeliveryAddressAPI.GetSellerAddress({
                ids: ids,
            })
                .then((res) => {
                    let shipment = ids.map((y) => {
                        let addr = _.find(res.data, (s) => s.user === y);
                        if (!addr) {
                            Swal.fire({
                                icon: "warning",
                                title: "Seller zip code not available",
                                text: "Seller didn't configured the zip code.Please try again later",
                                customClass: {
                                    cancelButton: "order-1 right-gap",
                                    confirmButton: "order-2",
                                    denyButton: "order-3",
                                },
                            });
                        }
                        return {
                            pick_code: addr.postCode,
                            pick_country: getCountryByCode(addr.country),
                            send_code: addr.postCode,
                            send_country: getCountryByCode(addr.country),
                            weight: selectedItems[0].product.weight,
                            height: selectedItems[0].product.height,
                            length: selectedItems[0].product.length,
                            width: selectedItems[0].product.width,
                        };
                    });
                    DeliveryAddressAPI.GetShippingAmount(shipment)
                        .then((x) => {
                            let ship = {};
                            let rt = {};
                            let curir = {};
                            if (x.data) {
                                x.data.result.forEach((y, index) => {
                                    let dv = y.rates.filter(
                                        (yt) =>
                                            yt.service_detail.indexOf(
                                                "dropoff"
                                            ) > -1
                                    );

                                    if (dv.length > 0) {
                                        curir[curItems[index].product._id] =
                                            dv[0].courier_name;
                                        ship[curItems[index].product._id] =
                                            dv[0].shipment_price;
                                        curItems[index].product.shippingFee =
                                            dv[0].shipment_price;
                                        rt[curItems[index].product._id] =
                                            dv[0].rate_id;
                                    }
                                });
                                setSelectedRate(rt);
                                setRates(x.data.result);

                                setSelectedItems(curItems);
                                setCalculating(false);
                                setShipment(ship);
                                setCourier(curir);
                            }
                        })
                        .catch(() => {
                            setCalculating(false);
                        });
                })
                .catch(() => {
                    setCalculating(false);
                });
        }
    }, [selectedAddress, carts]);

    useEffect(() => {
        if (
            location &&
            location.state &&
            location.state.checkout &&
            location.state.product
        ) {
            if (carts.cartItems && carts.cartItems.length > 0) {
                let cartItems = carts.cartItems
                    .filter((x) => {
                        return x.product._id === location.state.product;
                    })
                    .map((z) => {
                        if (shipment[z.product._id]) {
                            z.product.shippingFee = shipment[z.product._id];
                        }
                        return z;
                    });

                setSelectedItems(cartItems);
            }
        }
    }, [location, carts]);

    const handleChecked = (item, isChecked) => {
        if (isChecked) {
            setSelectedAddress(item);
        } else {
            setSelectedAddress({});
        }
    };

    useEffect(() => {
        setName("");
        setNickName("");
        setPhone("");
        setAddress("");
        setAddress1("");
        setPostCode("");
        setCurState("");
        setEmail("");
        setCity("");
        setForm(false);
    }, [isNew]);

    useEffect(() => {
        dispatch(getCartRequest());
        dispatch(getDeliveryAddressRequest());
    }, []);

    useEffect(() => {
        if (deliveryAddresses.length > 0 && !selectedAddress._id) {
            let defaultAdd = deliveryAddresses.filter((x) => x.isDefault);
            if (defaultAdd.length > 0) {
                setSelectedAddress(defaultAdd[0]);
            }
        }
    }, [deliveryAddresses]);

    const validate = () => {
        return (
            !IsNullOrEmpty(name) &&
            !IsNullOrEmpty(address) &&
            !IsNullOrEmpty(address1) &&
            !IsNullOrEmpty(city) &&
            !IsNullOrEmpty(state) &&
            !IsNullOrEmpty(postCode) &&
            !IsNullOrEmpty(phone) &&
            !IsNullOrEmpty(email) &&
            validPhone(phone) &&
            validEmail(email)
        );
    };

    const handleDelete = (id) => {
        dispatch(
            updateCartRequest({
                product: id,
                quantity: 0,
            })
        );
    };

    let cartList = [];
    if (carts && carts.cartItems) {
        cartList = carts.cartItems;
    }

    let prices = selectedItems.map((x) => {
        return x.product.price * x.quantity;
    });

    let shippingPrices = selectedItems.map((x) => {
        return x.product.shippingFee * x.quantity;
    });

    let qtys = selectedItems.map((x) => {
        return x.quantity;
    });

    let totalProductPrice = _.reduce(
        prices,
        function (memo, num) {
            return memo + num;
        },
        0
    );
    let totalShippingFee = _.reduce(
        shippingPrices,
        function (memo, num) {
            return memo + num;
        },
        0
    );
    let orderTotal = _.reduce(
        qtys,
        function (memo, num) {
            return memo + num;
        },
        0
    );

    let discounts = selectedItems.map((x) => {
        return discount * x.quantity;
    });

    let totalDiscount = _.reduce(
        discounts,
        function (memo, num) {
            return memo + num;
        },
        0
    );

    const options = [
        "Show some love to Material-UI",
        "Show all notification content",
        "Hide sensitive notification content",
        "Hide all notification content",
    ];

    const scrollH = (e) => {
        e = window.event || e;
        let delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
        scrollRef.current.scrollLeft -= delta * 40;
    };

    let curRate = {};

    if (rates.length > 0 && selectedItems.length > 0) {
        curRate = _.find(
            rates[0].rates,
            (x) => x.rate_id === selectedRate[selectedItems[0].product._id]
        );
    }

    if (calculating || selectedItems.length === 0) {
        return (
            <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
                <div className="">
                    <div className="mb-3">
                        <h2 className="text-xl font-bold text-ebony-color capitalize">
                            Buy Now
                        </h2>
                        <p className="text-md font-medium text-black-60">
                            Your items that are ready for checkout
                        </p>
                    </div>
                </div>
                <div className="flex-grow overflow-y-auto bg-white rounded-lg border border-t-0 border-black-10">
                    <div className="flex flex-col items-center justify-center mt-4 h-full">
                        <img src={uploadingImg} />
                        <p className="text-xl font-bold text-ebony-color capitalize">
                            Calculating...
                        </p>
                        <p className="text-md font-medium text-black-50 mt-3">
                            We’re calculating shipping fee
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
            <div className="">
                <div className="mb-3">
                    <h2 className="text-xl font-bold text-ebony-color capitalize">
                        Buy Now
                    </h2>
                    <p className="text-md font-medium text-black-60">
                        Your items that are ready for checkout
                    </p>
                </div>
            </div>

            <div className="flex-grow overflow-y-auto bg-white rounded-lg border border-t-0 border-black-10">
                <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-12 xl:col-span-7 p-4">
                        <div className="flex-1">
                            <h3 className="text-base font-bold text-ebony-color my-2">
                                Items
                            </h3>
                            <div className="col-span-12 xl:col-span-5 border border-black-10 rounded-lg p-4">
                                <div className="w-full overflow-x-auto sm:overflow-x-hidden xs:overflow-x-hidden">
                                    <div className="mb-14">
                                        {selectedItems.map((x) => {
                                            let isActive =
                                                selectedItems.filter(
                                                    (y) =>
                                                        y.product._id ===
                                                        x.product._id
                                                ).length > 0;
                                            if (!x.product.user) {
                                                return <p></p>;
                                            }

                                            return (
                                                <div
                                                    key={x.product.id}
                                                    className="flex gap-y-4 flex-col sm:flex-row justify-between mb-6"
                                                >
                                                    <div className="flex">
                                                        <img
                                                            src={
                                                                x.product.images
                                                            }
                                                            alt=""
                                                            className="w-[140px] h-[140px] rounded-lg mr-4"
                                                        />

                                                        <div className="flex w-full">
                                                            <div className="flex flex-col justify-between mr-20">
                                                                <div className="">
                                                                    <h4 className="text-sm font-medium text-ebony-color mb-0.5">
                                                                        {
                                                                            x
                                                                                .product
                                                                                .name
                                                                        }
                                                                    </h4>
                                                                    <Tooltip
                                                                        title={
                                                                            x
                                                                                .product
                                                                                .descriptions
                                                                        }
                                                                    >
                                                                        <p
                                                                            className="text-sm font-medium text-black-60"
                                                                            style={{
                                                                                overflow:
                                                                                    "hidden",
                                                                                textOverflow:
                                                                                    "ellipsis",
                                                                            }}
                                                                        >
                                                                            {
                                                                                x
                                                                                    .product
                                                                                    .descriptions
                                                                                    .length >
                                                                                    100
                                                                                    ? x.product.descriptions.slice(
                                                                                        0,
                                                                                        100
                                                                                    ) +
                                                                                    "..."
                                                                                    : x
                                                                                        .product
                                                                                        .descriptions
                                                                            }
                                                                        </p>
                                                                    </Tooltip>
                                                                </div>

                                                                <div className="flex items-center">
                                                                    <div className="mr-3">
                                                                        <h5 className="text-xs font-medium text-black-60 capitalize">
                                                                            4.9
                                                                            Rating
                                                                        </h5>
                                                                        <div className="flex items-center space-x-px">
                                                                            <span>
                                                                                <svg
                                                                                    width="12"
                                                                                    height="11"
                                                                                    viewBox="0 0 12 11"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                >
                                                                                    <path
                                                                                        d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                                        fill="#FFB800"
                                                                                    />
                                                                                </svg>
                                                                            </span>
                                                                            <span>
                                                                                <svg
                                                                                    width="12"
                                                                                    height="11"
                                                                                    viewBox="0 0 12 11"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                >
                                                                                    <path
                                                                                        d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                                        fill="#FFB800"
                                                                                    />
                                                                                </svg>
                                                                            </span>
                                                                            <span>
                                                                                <svg
                                                                                    width="12"
                                                                                    height="11"
                                                                                    viewBox="0 0 12 11"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                >
                                                                                    <path
                                                                                        d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                                        fill="#FFB800"
                                                                                    />
                                                                                </svg>
                                                                            </span>
                                                                            <span>
                                                                                <svg
                                                                                    width="12"
                                                                                    height="11"
                                                                                    viewBox="0 0 12 11"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                >
                                                                                    <path
                                                                                        d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                                        fill="#FFB800"
                                                                                    />
                                                                                </svg>
                                                                            </span>
                                                                            <span>
                                                                                <svg
                                                                                    width="12"
                                                                                    height="11"
                                                                                    viewBox="0 0 12 11"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                >
                                                                                    <path
                                                                                        d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                                        fill="#FFB800"
                                                                                    />
                                                                                </svg>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <p className="text-xs font-medium text-orange-color whitespace-nowrap capitalize">
                                                                        {
                                                                            x
                                                                                .product
                                                                                .warehouse
                                                                                .purcharse
                                                                        }{" "}
                                                                        sold
                                                                    </p>
                                                                </div>

                                                                <div className="flex items-center" style={{ visibility: "hidden" }}>
                                                                    <div className="grid grid-cols-3 w-[74px] h-[26px] rounded-[4px] mr-2.5">
                                                                        <button
                                                                            onClick={() => {
                                                                                dispatch(
                                                                                    updateCartRequest(
                                                                                        {
                                                                                            product:
                                                                                                x
                                                                                                    .product
                                                                                                    ._id,
                                                                                            quantity:
                                                                                                x.quantity -
                                                                                                1,
                                                                                        }
                                                                                    )
                                                                                );
                                                                            }}
                                                                            className="flex justify-center items-center border-[0.6px] border-black-20 border-r-0 rounded-tl-[4px]  rounded-bl-[4px]"
                                                                        >
                                                                            <svg
                                                                                width="8"
                                                                                height="2"
                                                                                viewBox="0 0 8 2"
                                                                                fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path
                                                                                    d="M7.33463 0.666504H0.667969"
                                                                                    stroke="black"
                                                                                    strokeOpacity="0.3"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                            </svg>
                                                                        </button>

                                                                        <span className="flex justify-center items-center p-1.5 border-[0.6px] border-black-20 text-extraSmall text-ebony-color font-medium">
                                                                            {
                                                                                x.quantity
                                                                            }
                                                                        </span>

                                                                        <button
                                                                            onClick={() => {
                                                                                dispatch(
                                                                                    updateCartRequest(
                                                                                        {
                                                                                            product:
                                                                                                x
                                                                                                    .product
                                                                                                    ._id,
                                                                                            quantity:
                                                                                                x.quantity +
                                                                                                1,
                                                                                        }
                                                                                    )
                                                                                );
                                                                            }}
                                                                            className="flex justify-center items-center border-[0.6px] border-black-20 border-l-0  rounded-tr-[4px] rounded-br-[4px]"
                                                                        >
                                                                            <svg
                                                                                width="14"
                                                                                height="14"
                                                                                viewBox="0 0 14 14"
                                                                                fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path
                                                                                    d="M6.66732 3.3335V6.66683M6.66732 6.66683V10.0002M6.66732 6.66683H10.0006M6.66732 6.66683L3.33398 6.66683"
                                                                                    stroke="black"
                                                                                    strokeOpacity="0.3"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                            </svg>
                                                                        </button>
                                                                    </div>

                                                                    <p
                                                                        onClick={() => {
                                                                            Swal.fire(
                                                                                {
                                                                                    icon: "warning",
                                                                                    title: "Remove from cart?",
                                                                                    text: "You need to add to cart again to checkout",
                                                                                    confirmButtonText:
                                                                                        "Remove",
                                                                                    showConfirmButton: true,
                                                                                    showCancelButton: true,
                                                                                    customClass:
                                                                                    {
                                                                                        cancelButton:
                                                                                            "order-1 right-gap",
                                                                                        confirmButton:
                                                                                            "order-2",
                                                                                        denyButton:
                                                                                            "order-3",
                                                                                    },
                                                                                }
                                                                            ).then(
                                                                                (
                                                                                    res
                                                                                ) => {
                                                                                    if (
                                                                                        res.isConfirmed
                                                                                    ) {
                                                                                        handleDelete(
                                                                                            x
                                                                                                .product
                                                                                                ._id
                                                                                        );
                                                                                    }
                                                                                }
                                                                            );
                                                                        }}
                                                                        className="text-xs font-medium text-orange-color capitalize"
                                                                    >
                                                                        Remove
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <Hidden implementation="js" only={["sm", "xs"]}>
                                                        <div className="flex flex-row sm:flex-col items-center justify-between sm:items-end sm:justify-end">
                                                            <p className="text-sm font-medium text-orange-color sm:mb-5 uppercase order-3 sm:order-1">
                                                                {x.product.currency}{" "}
                                                                {x.product.price}
                                                            </p>

                                                            {!calculating ? (
                                                                <div className="order-2 sm:order-2">
                                                                    <p className="text-xs font-medium text-orange-color sm:mb-1 order-2 sm:order-1">
                                                                        Select
                                                                        Courier
                                                                    </p>
                                                                    {calculating ? (
                                                                        <span className="text-xs">
                                                                            Loading
                                                                            Shipments
                                                                        </span>
                                                                    ) : (
                                                                        <List
                                                                            disablePadding
                                                                            component="nav"
                                                                            className="w-[240px] rounded-lg border border-black-10"
                                                                            aria-label="Device settings"
                                                                        >
                                                                            <ListItem
                                                                                button
                                                                                aria-haspopup="true"
                                                                                aria-controls="lock-menu"
                                                                                aria-label="when device is locked"
                                                                                onClick={
                                                                                    handleClickListItem
                                                                                }
                                                                            >
                                                                                <ListItemAvatar>
                                                                                    <Avatar
                                                                                        variant="rounded"
                                                                                        src={
                                                                                            curRate
                                                                                                ? curRate.courier_logo
                                                                                                : getImage(
                                                                                                    ""
                                                                                                )
                                                                                        }
                                                                                    />
                                                                                </ListItemAvatar>
                                                                                <ListItemText
                                                                                    primaryTypographyProps={{
                                                                                        className:
                                                                                            "overflow-text",
                                                                                        style: {
                                                                                            fontSize:
                                                                                                "0.9em",
                                                                                        },
                                                                                    }}
                                                                                    secondaryTypographyProps={{
                                                                                        className:
                                                                                            "overflow-text text-xs",
                                                                                        style: {
                                                                                            fontSize:
                                                                                                "0.7em",
                                                                                        },
                                                                                    }}
                                                                                    secondary={
                                                                                        curRate
                                                                                            ? curRate.courier_name
                                                                                            : "Select Courier"
                                                                                    }
                                                                                    primary={
                                                                                        curRate
                                                                                            ? userProfile
                                                                                                .country
                                                                                                .currency +
                                                                                            " " +
                                                                                            curRate.price
                                                                                            : "0.00"
                                                                                    }
                                                                                />
                                                                            </ListItem>
                                                                            <ListItemSecondaryAction
                                                                                style={{
                                                                                    top: "30%",
                                                                                }}
                                                                            >
                                                                                <ChevronDownIcon
                                                                                    onClick={
                                                                                        handleClickListItem
                                                                                    }
                                                                                />
                                                                            </ListItemSecondaryAction>
                                                                        </List>
                                                                    )}

                                                                    <Menu
                                                                        id="lock-menu"
                                                                        anchorEl={
                                                                            anchorEl
                                                                        }
                                                                        keepMounted
                                                                        open={Boolean(
                                                                            anchorEl
                                                                        )}
                                                                        onClose={
                                                                            handleClose
                                                                        }
                                                                    >
                                                                        {rates.length >
                                                                            0 &&
                                                                            rates[0].rates
                                                                                .filter(
                                                                                    (
                                                                                        yt
                                                                                    ) =>
                                                                                        yt.service_detail.indexOf(
                                                                                            "dropoff"
                                                                                        ) >
                                                                                        -1
                                                                                )
                                                                                .map(
                                                                                    (
                                                                                        yt,
                                                                                        index
                                                                                    ) => {
                                                                                        return (
                                                                                            <MenuItem
                                                                                                key={
                                                                                                    yt.rate_id
                                                                                                }
                                                                                                selected={
                                                                                                    index ===
                                                                                                    selectedIndex
                                                                                                }
                                                                                                onClick={(
                                                                                                    event
                                                                                                ) => {
                                                                                                    const yt1 =
                                                                                                        _.find(
                                                                                                            rates[0]
                                                                                                                .rates,
                                                                                                            (
                                                                                                                x
                                                                                                            ) =>
                                                                                                                x.rate_id ===
                                                                                                                yt.rate_id
                                                                                                        );
                                                                                                    let id =
                                                                                                        selectedItems[0]
                                                                                                            .product
                                                                                                            ._id;
                                                                                                    setSelectedRate(
                                                                                                        {
                                                                                                            ...selectedRate,
                                                                                                            [id]: yt1.rate_id,
                                                                                                        }
                                                                                                    );
                                                                                                    setShipment(
                                                                                                        {
                                                                                                            ...shipment,
                                                                                                            [id]: yt1.shipment_price,
                                                                                                        }
                                                                                                    );

                                                                                                    setCourier(
                                                                                                        {
                                                                                                            ...courier,
                                                                                                            [id]: yt1.courier_name,
                                                                                                        }
                                                                                                    );

                                                                                                    setSelectedItems(
                                                                                                        selectedItems.map(
                                                                                                            (
                                                                                                                zt
                                                                                                            ) => {
                                                                                                                if (
                                                                                                                    zt
                                                                                                                        .product
                                                                                                                        ._id ===
                                                                                                                    id
                                                                                                                ) {
                                                                                                                    zt.product.shippingFee =
                                                                                                                        yt1.shipment_price;
                                                                                                                }
                                                                                                                return zt;
                                                                                                            }
                                                                                                        )
                                                                                                    );
                                                                                                    handleMenuItemClick(
                                                                                                        event,
                                                                                                        index
                                                                                                    );
                                                                                                }}
                                                                                            >
                                                                                                <ListItem
                                                                                                    disableGutters
                                                                                                >
                                                                                                    <ListItemAvatar>
                                                                                                        <Avatar
                                                                                                            variant="rounded"
                                                                                                            src={
                                                                                                                yt.courier_logo
                                                                                                            }
                                                                                                        />
                                                                                                    </ListItemAvatar>
                                                                                                    <ListItemText
                                                                                                        primary={
                                                                                                            yt.courier_name
                                                                                                        }
                                                                                                        secondary={
                                                                                                            userProfile
                                                                                                                .country
                                                                                                                .currency +
                                                                                                            " " +
                                                                                                            yt.price +
                                                                                                            " (" +
                                                                                                            yt.delivery +
                                                                                                            ")"
                                                                                                        }
                                                                                                    />
                                                                                                </ListItem>
                                                                                            </MenuItem>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                    </Menu>
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )}

                                                            {!calculating && (
                                                                <div className="order-1 sm:order-3">
                                                                    <TextField
                                                                        fullWidth
                                                                        label="Enter discount code"
                                                                        placeholder="Enter discount code"
                                                                        value={
                                                                            discountCode
                                                                        }
                                                                        margin="dense"
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            setDiscountCode(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        helperText={
                                                                            parseFloat(
                                                                                discount
                                                                            ) > 0
                                                                                ? x
                                                                                    .product
                                                                                    .currency +
                                                                                " " +
                                                                                discount *
                                                                                x.quantity +
                                                                                " Discount Applied"
                                                                                : ""
                                                                        }
                                                                        InputProps={{
                                                                            endAdornment:
                                                                                (
                                                                                    <InputAdornment position="end">
                                                                                        <button
                                                                                            onClick={() => {
                                                                                                if (
                                                                                                    discountCode ===
                                                                                                    x
                                                                                                        .product
                                                                                                        .discountCode
                                                                                                ) {
                                                                                                    let dis =
                                                                                                        ((parseFloat(
                                                                                                            x
                                                                                                                .product
                                                                                                                .price
                                                                                                        ) +
                                                                                                            parseFloat(
                                                                                                                x
                                                                                                                    .product
                                                                                                                    .shippingFee
                                                                                                            )) *
                                                                                                            parseFloat(
                                                                                                                x
                                                                                                                    .product
                                                                                                                    .discountPer
                                                                                                            )) /
                                                                                                        100;

                                                                                                    setSelectedItems(
                                                                                                        selectedItems.map(
                                                                                                            (
                                                                                                                zt,
                                                                                                                inz
                                                                                                            ) => {
                                                                                                                if (
                                                                                                                    inz ===
                                                                                                                    0
                                                                                                                ) {
                                                                                                                    zt.product.discount =
                                                                                                                        dis;
                                                                                                                }

                                                                                                                return zt;
                                                                                                            }
                                                                                                        )
                                                                                                    );
                                                                                                    setDiscount(
                                                                                                        dis
                                                                                                    );
                                                                                                } else {
                                                                                                    Swal.fire(
                                                                                                        {
                                                                                                            title: "Invalid Discount Code",
                                                                                                            text: "Please provide the valid discount code.",
                                                                                                            icon: "warning",

                                                                                                            confirmButtonText:
                                                                                                                "Close",
                                                                                                            customClass:
                                                                                                            {
                                                                                                                cancelButton:
                                                                                                                    "order-1 right-gap",
                                                                                                                confirmButton:
                                                                                                                    "order-2",
                                                                                                                denyButton:
                                                                                                                    "order-3",
                                                                                                            },
                                                                                                        }
                                                                                                    );
                                                                                                }
                                                                                            }}
                                                                                            className="text-black-50 text-sm py-1 px-2 bg-white border border-[#D1D5DB] rounded-md"
                                                                                        >
                                                                                            Apply
                                                                                        </button>
                                                                                    </InputAdornment>
                                                                                ),
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Hidden>
                                                    <Hidden implementation="js" only={["xl", "lg", "md"]}>
                                                        <div className="flex flex-col items-center justify-center">
                                                            <p className="text-md font-medium text-orange-color sm:mb-5 uppercase">
                                                                {x.product.currency}{" "}
                                                                {x.product.price}
                                                            </p>

                                                            {!calculating && (
                                                                <div className="my-4">
                                                                    <TextField
                                                                        fullWidth
                                                                        label="Enter discount code"
                                                                        placeholder="Enter discount code"
                                                                        value={
                                                                            discountCode
                                                                        }
                                                                        margin="dense"
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            setDiscountCode(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        helperText={
                                                                            parseFloat(
                                                                                discount
                                                                            ) > 0
                                                                                ? x
                                                                                    .product
                                                                                    .currency +
                                                                                " " +
                                                                                discount *
                                                                                x.quantity +
                                                                                " Discount Applied"
                                                                                : ""
                                                                        }
                                                                        InputProps={{
                                                                            endAdornment:
                                                                                (
                                                                                    <InputAdornment position="end">
                                                                                        <button
                                                                                            onClick={() => {
                                                                                                if (
                                                                                                    discountCode ===
                                                                                                    x
                                                                                                        .product
                                                                                                        .discountCode
                                                                                                ) {
                                                                                                    let dis =
                                                                                                        ((parseFloat(
                                                                                                            x
                                                                                                                .product
                                                                                                                .price
                                                                                                        ) +
                                                                                                            parseFloat(
                                                                                                                x
                                                                                                                    .product
                                                                                                                    .shippingFee
                                                                                                            )) *
                                                                                                            parseFloat(
                                                                                                                x
                                                                                                                    .product
                                                                                                                    .discountPer
                                                                                                            )) /
                                                                                                        100;

                                                                                                    setSelectedItems(
                                                                                                        selectedItems.map(
                                                                                                            (
                                                                                                                zt,
                                                                                                                inz
                                                                                                            ) => {
                                                                                                                if (
                                                                                                                    inz ===
                                                                                                                    0
                                                                                                                ) {
                                                                                                                    zt.product.discount =
                                                                                                                        dis;
                                                                                                                }

                                                                                                                return zt;
                                                                                                            }
                                                                                                        )
                                                                                                    );
                                                                                                    setDiscount(
                                                                                                        dis
                                                                                                    );
                                                                                                } else {
                                                                                                    Swal.fire(
                                                                                                        {
                                                                                                            title: "Invalid Discount Code",
                                                                                                            text: "Please provide the valid discount code.",
                                                                                                            icon: "warning",

                                                                                                            confirmButtonText:
                                                                                                                "Close",
                                                                                                            customClass:
                                                                                                            {
                                                                                                                cancelButton:
                                                                                                                    "order-1 right-gap",
                                                                                                                confirmButton:
                                                                                                                    "order-2",
                                                                                                                denyButton:
                                                                                                                    "order-3",
                                                                                                            },
                                                                                                        }
                                                                                                    );
                                                                                                }
                                                                                            }}
                                                                                            className="text-black-50 text-sm py-1 px-2 bg-white border border-[#D1D5DB] rounded-md"
                                                                                        >
                                                                                            Apply
                                                                                        </button>
                                                                                    </InputAdornment>
                                                                                ),
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}

                                                            {!calculating ? (
                                                                <div className="order-2 sm:order-2">
                                                                    <p className="text-xs font-medium text-orange-color sm:mb-1">
                                                                        Select
                                                                        Courier
                                                                    </p>
                                                                    {calculating ? (
                                                                        <span className="text-xs">
                                                                            Loading
                                                                            Shipments
                                                                        </span>
                                                                    ) : (
                                                                        <List
                                                                            disablePadding
                                                                            component="nav"
                                                                            className="w-[240px] rounded-lg border border-black-10"
                                                                            aria-label="Device settings"
                                                                        >
                                                                            <ListItem
                                                                                button
                                                                                aria-haspopup="true"
                                                                                aria-controls="lock-menu"
                                                                                aria-label="when device is locked"
                                                                                onClick={
                                                                                    handleClickListItem
                                                                                }
                                                                            >
                                                                                <ListItemAvatar>
                                                                                    <Avatar
                                                                                        variant="rounded"
                                                                                        src={
                                                                                            curRate
                                                                                                ? curRate.courier_logo
                                                                                                : getImage(
                                                                                                    ""
                                                                                                )
                                                                                        }
                                                                                    />
                                                                                </ListItemAvatar>
                                                                                <ListItemText
                                                                                    primaryTypographyProps={{
                                                                                        className:
                                                                                            "overflow-text",
                                                                                        style: {
                                                                                            fontSize:
                                                                                                "0.9em",
                                                                                        },
                                                                                    }}
                                                                                    secondaryTypographyProps={{
                                                                                        className:
                                                                                            "overflow-text text-xs",
                                                                                        style: {
                                                                                            fontSize:
                                                                                                "0.7em",
                                                                                        },
                                                                                    }}
                                                                                    secondary={
                                                                                        curRate
                                                                                            ? curRate.courier_name
                                                                                            : "Select Courier"
                                                                                    }
                                                                                    primary={
                                                                                        curRate
                                                                                            ? userProfile
                                                                                                .country
                                                                                                .currency +
                                                                                            " " +
                                                                                            curRate.price
                                                                                            : "0.00"
                                                                                    }
                                                                                />
                                                                            </ListItem>
                                                                            <ListItemSecondaryAction
                                                                                style={{
                                                                                    top: "30%",
                                                                                }}
                                                                            >
                                                                                <ChevronDownIcon
                                                                                    onClick={
                                                                                        handleClickListItem
                                                                                    }
                                                                                />
                                                                            </ListItemSecondaryAction>
                                                                        </List>
                                                                    )}

                                                                    <Menu
                                                                        id="lock-menu"
                                                                        anchorEl={
                                                                            anchorEl
                                                                        }
                                                                        keepMounted
                                                                        open={Boolean(
                                                                            anchorEl
                                                                        )}
                                                                        onClose={
                                                                            handleClose
                                                                        }
                                                                    >
                                                                        {rates.length >
                                                                            0 &&
                                                                            rates[0].rates
                                                                                .filter(
                                                                                    (
                                                                                        yt
                                                                                    ) =>
                                                                                        yt.service_detail.indexOf(
                                                                                            "dropoff"
                                                                                        ) >
                                                                                        -1
                                                                                )
                                                                                .map(
                                                                                    (
                                                                                        yt,
                                                                                        index
                                                                                    ) => {
                                                                                        return (
                                                                                            <MenuItem
                                                                                                key={
                                                                                                    yt.rate_id
                                                                                                }
                                                                                                selected={
                                                                                                    index ===
                                                                                                    selectedIndex
                                                                                                }
                                                                                                onClick={(
                                                                                                    event
                                                                                                ) => {
                                                                                                    const yt1 =
                                                                                                        _.find(
                                                                                                            rates[0]
                                                                                                                .rates,
                                                                                                            (
                                                                                                                x
                                                                                                            ) =>
                                                                                                                x.rate_id ===
                                                                                                                yt.rate_id
                                                                                                        );
                                                                                                    let id =
                                                                                                        selectedItems[0]
                                                                                                            .product
                                                                                                            ._id;
                                                                                                    setSelectedRate(
                                                                                                        {
                                                                                                            ...selectedRate,
                                                                                                            [id]: yt1.rate_id,
                                                                                                        }
                                                                                                    );
                                                                                                    setShipment(
                                                                                                        {
                                                                                                            ...shipment,
                                                                                                            [id]: yt1.shipment_price,
                                                                                                        }
                                                                                                    );

                                                                                                    setCourier(
                                                                                                        {
                                                                                                            ...courier,
                                                                                                            [id]: yt1.courier_name,
                                                                                                        }
                                                                                                    );

                                                                                                    setSelectedItems(
                                                                                                        selectedItems.map(
                                                                                                            (
                                                                                                                zt
                                                                                                            ) => {
                                                                                                                if (
                                                                                                                    zt
                                                                                                                        .product
                                                                                                                        ._id ===
                                                                                                                    id
                                                                                                                ) {
                                                                                                                    zt.product.shippingFee =
                                                                                                                        yt1.shipment_price;
                                                                                                                }
                                                                                                                return zt;
                                                                                                            }
                                                                                                        )
                                                                                                    );
                                                                                                    handleMenuItemClick(
                                                                                                        event,
                                                                                                        index
                                                                                                    );
                                                                                                }}
                                                                                            >
                                                                                                <ListItem
                                                                                                    disableGutters
                                                                                                >
                                                                                                    <ListItemAvatar>
                                                                                                        <Avatar
                                                                                                            variant="rounded"
                                                                                                            src={
                                                                                                                yt.courier_logo
                                                                                                            }
                                                                                                        />
                                                                                                    </ListItemAvatar>
                                                                                                    <ListItemText
                                                                                                        primary={
                                                                                                            yt.courier_name
                                                                                                        }
                                                                                                        secondary={
                                                                                                            userProfile
                                                                                                                .country
                                                                                                                .currency +
                                                                                                            " " +
                                                                                                            yt.price +
                                                                                                            " (" +
                                                                                                            yt.delivery +
                                                                                                            ")"
                                                                                                        }
                                                                                                    />
                                                                                                </ListItem>
                                                                                            </MenuItem>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                    </Menu>
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )}


                                                        </div>
                                                    </Hidden>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-12 xl:col-span-5 h-fit rounded-lg pt-4 pr-4 p-2">
                        <div className="mb-[18px]">
                            <div className="w-full">
                                <h3 className="text-base font-bold text-ebony-color my-2">
                                    Select Address
                                    <a
                                        onClick={() => isAdd(true)}
                                        className="float-right text-orange-color"
                                    >
                                        Add new address
                                    </a>
                                </h3>
                                <Accordion
                                    preExpanded={["one1"]}
                                    allowZeroExpanded
                                    className="rounded-lg border border-black-10 mb-3"
                                >
                                    <AccordionItem uuid="one1" className="active">
                                        <AccordionItemHeading
                                            onClick={handleAccordionOne}
                                        >
                                            <AccordionItemButton className="p-4 before:hidden flex justify-between items-center accordionToggleOne">
                                                <h3 className="text-md font-medium text-black-60 capitalize">
                                                    Saved address
                                                </h3>
                                                <span
                                                    className={`${!accordionOne &&
                                                        "rotate-180"
                                                        }`}
                                                >
                                                    <svg
                                                        width="10"
                                                        height="6"
                                                        viewBox="0 0 10 6"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M1.33203 4.5835L4.91962 1.021L8.50721 4.5835"
                                                            stroke="black"
                                                            strokeOpacity="0.5"
                                                            strokeWidth="1.1875"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                            </AccordionItemButton>
                                        </AccordionItemHeading>{" "}
                                        <AccordionItemPanel className="p-4 pt-0">
                                            <List>
                                                {deliveryAddresses &&
                                                    deliveryAddresses.map(
                                                        (item) => {
                                                            return (
                                                                <ListItem
                                                                    classes={{
                                                                        root: "p-1",
                                                                    }}
                                                                    disableGutters
                                                                >
                                                                    <ListItemText
                                                                        style={{
                                                                            maxWidth:
                                                                                "80%",
                                                                        }}
                                                                        classes={{
                                                                            multiline:
                                                                                "my-0",
                                                                        }}
                                                                        primary={
                                                                            <span className="text-bold font-black">
                                                                                {
                                                                                    item.name
                                                                                }
                                                                            </span>
                                                                        }
                                                                        secondary={
                                                                            <span className="font-black text-black">
                                                                                {item.address +
                                                                                    "," +
                                                                                    item.subAddress +
                                                                                    "," +
                                                                                    item.city +
                                                                                    "-" +
                                                                                    item.postCode}
                                                                                <br />
                                                                                {
                                                                                    item.state
                                                                                }
                                                                                ,
                                                                                {item.country ===
                                                                                    "+60"
                                                                                    ? "Malaysia"
                                                                                    : item.country ===
                                                                                        "+1"
                                                                                        ? "United States"
                                                                                        : "Singapore"}
                                                                                <br />
                                                                                {
                                                                                    item.phone
                                                                                }
                                                                                ,
                                                                                {
                                                                                    item.email
                                                                                }
                                                                            </span>
                                                                        }
                                                                    />
                                                                    <ListItemSecondaryAction>
                                                                        <Checkbox
                                                                            checked={
                                                                                selectedAddress._id ===
                                                                                item._id
                                                                            }
                                                                            disabled={
                                                                                isNew
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                handleChecked(
                                                                                    item,
                                                                                    e
                                                                                        .target
                                                                                        .checked
                                                                                )
                                                                            }
                                                                        />
                                                                    </ListItemSecondaryAction>
                                                                </ListItem>
                                                            );
                                                        }
                                                    )}
                                            </List>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                </Accordion>
                                {add && (
                                    <AddAddress
                                        onAdd={() => {
                                            setSelectedAddress({});
                                            isAdd(false);
                                        }}
                                        onClose={() =>
                                            deliveryAddresses.length > 0
                                                ? isAdd(false)
                                                : isAdd(true)
                                        }
                                    />
                                )}
                                <h3 className="text-base font-bold text-ebony-color my-2">
                                    Order Summary
                                </h3>
                                <div className="bg-white rounded-full border border-black-10 rounded-xl p-3">
                                    <div className="flex justify-between items-center my-2">
                                        <span className="text-black-50">
                                            Shipping Fee{" "}
                                        </span>
                                        <span className="text-black-50">
                                            {calculating
                                                ? "calculating..."
                                                : (!isNew &&
                                                    !selectedAddress._id) ||
                                                    (isNew &&
                                                        IsNullOrEmpty(postCode))
                                                    ? "Calculated at next step"
                                                    : currency +
                                                    " " +
                                                    totalShippingFee.toFixed(2)}
                                        </span>
                                    </div>
                                    <div className="flex justify-between items-center my-2">
                                        <span className="text-black-50">
                                            Order Total
                                        </span>
                                        <span className="text-black-50">
                                            {orderTotal}
                                        </span>
                                    </div>
                                    {totalDiscount > 0 && (
                                        <div className="flex justify-between items-center my-2">
                                            <span className="text-black-50">
                                                Discount
                                            </span>
                                            <span className="text-black-50">
                                                {currency + " " + totalDiscount}
                                            </span>
                                        </div>
                                    )}
                                    <div className="flex justify-between items-center my-2">
                                        <span className="text-black-50">
                                            Payable Amount
                                        </span>
                                        <span className="text-orange-color">
                                            {currency}{" "}
                                            {(
                                                totalProductPrice +
                                                totalShippingFee -
                                                totalDiscount
                                            ).toFixed(2)}
                                        </span>
                                    </div>
                                </div>
                                <button
                                    disabled={calculating}
                                    className="py-2.5 px-5 mt-4 text-sm rounded-lg border border-transparent bg-orange-color text-white font-bold capitalize float-right"
                                    onClick={() => setConfirmPayment(true)}
                                >
                                    Proceed to payment
                                </button>
                                <Dialog
                                    open={confirmPayment}
                                    onClose={() => setConfirmPayment(false)}
                                >
                                    <DialogContent>
                                        {!calculating &&
                                            confirmPayment &&
                                            selectedItems.length > 0 &&
                                            rates.length > 0 &&
                                            selectedItems[0].product
                                                .shippingFee > 0 && (
                                                <OrderPayment
                                                    items={selectedItems}
                                                    cartId={carts._id}
                                                    courier={courier}
                                                    totalPrices={(
                                                        totalProductPrice +
                                                        totalShippingFee
                                                    ).toFixed(2)}
                                                    selectedAddress={
                                                        selectedAddress
                                                    }
                                                    discounts={{
                                                        [selectedItems[0]
                                                            .product._id]: {
                                                            discount: discount,
                                                        },
                                                    }}
                                                    shipment={shipment}
                                                    onCancel={() =>
                                                        setConfirmPayment(false)
                                                    }
                                                />
                                            )}
                                    </DialogContent>
                                </Dialog>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InstantCart;
